// ภาพถ่ายจริงบนหัวหน้าเล่น หนึ่งภาพต่อประเภทพื้นที่ (ภาพ public domain หรือ CC0 จาก Wikimedia Commons)
// ไฟล์ภาพและเครดิตสร้างด้วย npm run fetch:photos (scripts/fetch-hero-photos.ts)
// ประเภทพื้นที่ที่ยังไม่มีภาพใช้ภาพ default ถ้าไม่มีเลยหัวจะเป็นภาพป่าที่วาดด้วย CSS แทน

import type { BiomeId } from "../geo/biomes";
import { GENERATED_PHOTOS } from "./hero-photos.generated";

export type HeroKey = BiomeId | "default";

export interface HeroPhoto {
  file: string; // ที่อยู่ของไฟล์บนเว็บ เช่น /img/hero/mangrove.jpg
  title: string; // ชื่อไฟล์ใน Commons
  artist: string;
  license: string; // เช่น Public domain, CC0
  source: string; // หน้าของภาพใน Commons
}

/** ภาพสำหรับประเภทพื้นที่นี้ (ป่าชายเลนชนะประเภทพื้นที่หลักของช่อง) */
export function heroPhoto(biome: BiomeId | null | undefined, mangrove = false, photos = GENERATED_PHOTOS): HeroPhoto | null {
  if (mangrove && photos.mangrove) return photos.mangrove;
  return (biome && photos[biome]) || photos.default || null;
}
